import React from "react";
import HeroCarousel from "../HeroCarousel/HeroCarousel";
import HomeCourses from "../HomeCourses/HomeCourses";


const Home = () => {
  
  return (
    <main>
      <HeroCarousel />
      <HomeCourses />
    </main>
  );
};

export default Home;
